import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import { SfcModule } from "@sfc/angular";
import { ActivatedRoute, NavigationEnd, Route, Router } from "@angular/router";
import { filter } from "rxjs";
import { NavServiceService } from "../services/navigation/nav-service.service";
import { Paths } from "./header.module";

@Component({
    selector: 'app-header',
    imports: [
      SfcModule
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class HeaderComponent implements OnInit {

  public pageTitle: string | undefined;

  public routes: Route[] = [];
  private navigation = inject(NavServiceService);

  //TODO: Variables for dynamic icons, this does not work with sfc
  private icons = ['archiverulesoverview', 'connectors', 'merge','archiverulelabels','auditarchiverulelabels'];
  private PATH: Paths = {
    archiverulesoverview: 'rds-icon-folder',
    connectors: 'rds-icon-box-arrow-down',
    merge: 'rds-icon-arrow-curve-repeat',
    archiverulelabels: 'rds-icon-arrow-curve-repeat'
  }


  constructor(private router: Router, private activateRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.routes = this.getRoutes();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        const route = this.getChild(this.activateRoute);
        route.data.subscribe((data: any) => {
          this.pageTitle = data.title
        })
      });
  }

  private getRoutes(): Route[] {
    return this.navigation.getNavigationRoutes();
  }

  getChild(activatedRoute: ActivatedRoute): any {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  //TODO: This will be use to get the dynamic icons
  public getIcon(path: any) {
    if (!this.icons.includes(path)) {
      return;
    }
    return this.PATH[path as keyof Paths];
  }
}
